/* eslint-disable no-param-reassign */
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from '../../components/layout/Table'
import cauHinhBanPhuProcessor from '../../processor/cauHinhBanPhuProcessor'

export default function ThietLapThamSo() {
  const modeTitle = 'Thay đổi cấu hình bản sao'
  const processor = cauHinhBanPhuProcessor

  const toast = useSelector((store) => store.notify.toast)
  const [datas, setDatas] = useState([])

  const column = [
    { value: 'name', name: 'Tên', sortable: true, width: '50%' },
    {
      name: 'Giá trị',
      width: '50%',
      render: (data) => {
        return (
          <>
            <InputText
              value={data.value}
              onChange={(event) => {
                data.value = event.target.value
                setDatas([...datas])
              }}
              disabled={data.code === 'SoLuonBanSaoDaCapThoiDiemHienTai'}
            />
          </>
        )
      },
    },
  ]

  const getThamSo = async () => {
    const rs = await processor.getAllCauHinh()
    setDatas(rs)
  }

  useEffect(() => {
    getThamSo()
  }, [])

  const save = async () => {
    const rs = await processor.updateMany(datas)
    if (!rs.isSuccess) {
      await getThamSo()
    }
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
  }

  return (
    <>
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>{modeTitle}</h4>
          <div>
            <Button icon="pi pi-save" className="p-button-success" onClick={save} label="Lưu" />
          </div>
        </div>
        <div className="card">
          <Table data={datas} column={column} paginator={false} />
        </div>
      </div>
    </>
  )
}
